import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className }) => (
  <span className={`block overflow-hidden ${className || ""}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeIn = ({ children, delay = 0, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.9, delay, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ label, title, subtitle, dark = false, center = false }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl`}>
    {label && (
      <Reveal>
        <span className="inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.24em] text-gold">
          <span className="h-px w-8 bg-gold inline-block" />
          {label}
          {center && <span className="h-px w-8 bg-gold inline-block" />}
        </span>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2
        className={`mt-4 text-2xl sm:text-3xl lg:text-[2.6rem] font-semibold leading-[1.18] tracking-tight ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className={`mt-4 text-sm sm:text-base lg:text-lg leading-relaxed ${dark ? "text-white/65" : "text-ink-soft"}`}>
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
